"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateError = void 0;
const generate_error_message_1 = require("../generate-error-message");
const zod_1 = require("zod");
/**
 * Converts Zod Errors to generic Errors.
 * @export
 * @param {unknown} error
 * @param {ErrorMessageOptions} [options]
 * @return {*}  {Error}
 */
function generateError(error, options) {
    if (error instanceof zod_1.z.ZodError) {
        const message = (0, generate_error_message_1.generateErrorMessage)(error.issues, options);
        return new Error(message);
    }
    if (error instanceof Error) {
        return error;
    }
    return new Error('Unknown error');
}
exports.generateError = generateError;
